(function(){
"use strict";
function init(root){
if(root.dataset.trvReady)return;root.dataset.trvReady="1";
var DATA={};try{DATA=JSON.parse(root.querySelector("[data-trv-data]").textContent);}catch(e){}
var CONFIG=DATA.config||{};CONFIG.firstBlock=CONFIG.firstBlock||8;CONFIG.pageSize=CONFIG.pageSize||16;
var JUDGEME_REVIEWS=DATA.judgeme||[],TRUSTPILOT_REVIEWS=DATA.trustpilot||[],VIDEO_REVIEWS=DATA.videos||[];
function q(name){return root.querySelector('[data-trv="'+name+'"]');}
function px(c){return c.split(" ").filter(Boolean).map(function(x){return "trv-"+x;}).join(" ");}
var JM_IMGIX = "https://judgeme.imgix.net/tobios-kits/";
var JM_S3 = "https://s3.amazonaws.com/me.judge.review-images/tobios-kits/";
var MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function el(tag, cls, text){var e=document.createElement(tag);if(cls)e.className=px(cls);if(text!=null)e.textContent=text;return e;}
function icon(name){return el("i","i i-"+name);}
function fmtDate(s){var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(s||"");return m?MONTHS[+m[2]-1]+" "+(+m[3])+", "+m[1]:"";}
function cleanName(n,fallback){
  n=(n||"").trim().replace(/\s+/g," ");
  if(!n)return fallback||"Verified buyer";
  if(n===n.toUpperCase())n=n.toLowerCase().replace(/(^|[\s.'-])\S/g,function(c){return c.toUpperCase();});
  if(CONFIG.shortNames){var p=n.split(" ");if(p.length>1&&!/\.$/.test(p[p.length-1])){
    var s=p.length>2&&/^(mc|mac|van|von|de|del|da|di|le|la|st)$/i.test(p[p.length-2])?p[p.length-2]:p[p.length-1];
    n=p[0]+" "+s.charAt(0).toUpperCase()+".";}}
  return n;
}
function splitText(b,max){
  b=(b||"").trim();max=max||48;
  if(!b)return {t:"",q:""};
  if(b.length<=max&&b.indexOf("\n")<0)return {t:b,q:""};
  var m=new RegExp("^(.{6,"+max+"}?[.!?])(\\s+|(?=[A-Z]))([\\s\\S]+)$").exec(b);
  if(m&&m[1].indexOf("\n")<0)return {t:m[1],q:m[3]};
  return {t:"",q:b};
}
function imgSrc(f,w,h){return JM_IMGIX+f+"?auto=format,compress&fit=crop&w="+w+"&h="+h;}
function who(name,date){
  var w=el("div","who"),info=el("div");
  w.appendChild(el("span","av",name.charAt(0)));
  info.appendChild(el("p","nm",name));
  var d=fmtDate(date); if(d)info.appendChild(el("p","dt",d));
  w.appendChild(info);return w;
}
function textBlock(t,q,clampLen){
  var box=el("div","txt");
  if(t)box.appendChild(el("p","ttl",t));
  if(q){
    var p=el("p","qt",q);box.appendChild(p);
    if(q.length>clampLen){
      p.classList.add("trv-clamp");
      var more=el("button","more","Read more");more.type="button";
      more.addEventListener("click",function(){var c=p.classList.toggle("trv-clamp");more.textContent=c?"Read more":"Show less";});
      box.appendChild(more);
    }
  }
  return box;
}

var eagerLeft = 4;
function photoCard(r, idx){
  var a=el("article","card jm"), name=cleanName(r.n), tx=splitText(r.b);
  var tall = (idx % 5 === 3);
  var w=640, h=tall?800:550;
  var ph=el("button","ph"+(tall?" tall":""));ph.type="button";
  ph.setAttribute("aria-label","View photos from "+name+"'s review");
  var img=new Image();
  img.alt="Photo from "+name+"'s Tobio's review";
  img.width=w;img.height=h;img.decoding="async";
  if(eagerLeft>0){eagerLeft--; if(eagerLeft>=2) img.setAttribute("fetchpriority","high");}
  else img.loading="lazy";
  img.sizes="(max-width:760px) 92vw, (max-width:1100px) 46vw, 330px";
  img.srcset=[320,480,640,960].map(function(x){return imgSrc(r.i[0],x,Math.round(x*h/w))+" "+x+"w";}).join(",");
  img.src=imgSrc(r.i[0],w,h);
  img.onerror=function(){img.onerror=null;img.removeAttribute("srcset");img.src=JM_S3+r.i[0];};
  ph.appendChild(img);
  if(r.v){var b=el("span","badge");b.appendChild(el("i","i-verified"));b.appendChild(document.createTextNode("Verified user"));ph.appendChild(b);}
  if(r.i.length>1)ph.appendChild(el("span","cnt","+"+(r.i.length-1)));
  ph.addEventListener("click",function(){openLB(r,0);});
  a.appendChild(ph);
  var body=el("div","card-body"),st=el("div","jm-stars");
  st.setAttribute("role","img");st.setAttribute("aria-label",(r.r||5)+" out of 5 stars");
  for(var s=0;s<(r.r||5);s++)st.appendChild(icon("star"));
  body.appendChild(st);
  if(tx.t||tx.q)body.appendChild(textBlock(tx.t,tx.q,240));
  body.appendChild(who(name,r.d));
  a.appendChild(body);
  return a;
}
function tpStars(n,box){for(var s=0;s<5;s++){var t=el("span","tp-tile");var f=Math.max(0,Math.min(1,n-s));t.style.setProperty("--fill",(f*100)+"%");t.appendChild(icon("star-o"));box.appendChild(t);}return box;}
var tpCount=0;
function tpCard(r){
  var a=el("article","card tp"+(tpCount++%3===1?" alt":"")),body=el("div","card-body"),head=el("div","tp-head");
  var st=tpStars(r.rating||5,el("span","tp-stars"));st.setAttribute("role","img");st.setAttribute("aria-label",(r.rating||5)+" out of 5 stars on Trustpilot");
  head.appendChild(st);
  var br=el("span","tp-brand");br.appendChild(icon("star"));br.appendChild(document.createTextNode("Trustpilot"));head.appendChild(br);
  body.appendChild(head);
  var title=(r.title||"").trim(),txt=(r.body||"").trim();
  if(/(…|\.\.\.)$/.test(title)){
    var sp=splitText(txt,72);if(sp.t&&sp.q){title=sp.t;txt=sp.q;}
  }
  body.appendChild(textBlock(title,txt,260));
  body.appendChild(who(cleanName(r.name,"Trustpilot reviewer"),r.date));
  a.appendChild(body);return a;
}
function videoCard(v){
  var b=el("div","vid");b.setAttribute("role","button");b.tabIndex=0;
  var name=v.name?cleanName(v.name):"";b.setAttribute("aria-label","Play video review"+(name?" from "+name:""));
  var bg=null;
  if(v.poster){var p=new Image();p.src=v.poster;p.alt="";p.loading="lazy";p.decoding="async";p.width=324;p.height=474;b.appendChild(p);}
  else{bg=document.createElement("video");bg.muted=true;bg.playsInline=true;bg.preload="none";bg.setAttribute("playsinline","");bg.setAttribute("aria-hidden","true");b.appendChild(bg);lazyFrame(bg,v.src);}
  var tag=el("span","vtag");tag.appendChild(icon("play-o"));tag.appendChild(document.createTextNode("Video"));
  var ui=el("div","vid-ui");ui.appendChild(tag);ui.appendChild(el("span","vplay"));
  var info=el("div","vinfo");if(v.title)info.appendChild(el("p","ttl",v.title));if(name)info.appendChild(who(name,v.date));ui.appendChild(info);
  b.appendChild(ui);
  function play(){
    if(b.classList.contains("trv-playing"))return;
    var vd=bg||document.createElement("video");
    if(!bg){vd.src=v.src;if(v.poster)vd.poster=v.poster;b.appendChild(vd);}
    else if(!vd.getAttribute("src"))vd.src=v.src;
    vd.muted=false;vd.controls=true;vd.playsInline=true;vd.preload="auto";vd.removeAttribute("aria-hidden");
    try{vd.currentTime=0;}catch(e){}
    b.classList.add("trv-playing");b.removeAttribute("role");b.removeAttribute("tabindex");vd.play().catch(function(){});
  }
  b.addEventListener("click",play);
  b.addEventListener("keydown",function(e){if(e.key==="Enter"||e.key===" "){e.preventDefault();play();}});
  return b;
}

var frameIO="IntersectionObserver" in window?new IntersectionObserver(function(es){
  es.forEach(function(e){if(!e.isIntersecting)return;var vd=e.target;frameIO.unobserve(vd);
    if(!vd.getAttribute("src")){vd.preload="metadata";vd.src=vd.dataset.src;}});
},{rootMargin:"600px 0px"}):null;
function lazyFrame(vd,src){vd.dataset.src=src+"#t=0.1";if(frameIO)frameIO.observe(vd);else{vd.preload="metadata";vd.src=vd.dataset.src;}}

var LEAD="ptvtpttpvtpt";
function buildFeed(){
  var src={p:JUDGEME_REVIEWS.slice(),t:TRUSTPILOT_REVIEWS.slice(),v:VIDEO_REVIEWS.slice()},out=[];
  function take(type){if(src[type].length){out.push({type:type,data:src[type].shift()});return true;}return false;}
  for(var i=0;i<LEAD.length;i++)take(LEAD[i])||take("p")||take("t")||take("v");
  var extras=src.t.length+src.v.length, step=extras?Math.max(2,Math.floor(src.p.length/extras)):0, n=0, vEvery=src.v.length?Math.max(3,Math.floor((src.t.length+src.v.length)/src.v.length)):0, k=0;
  while(src.p.length||src.t.length||src.v.length){
    if(src.p.length&&(!step||n<step)){take("p");n++;continue;}
    n=0;k++;
    if(src.v.length&&(k%vEvery===1||!src.t.length))take("v");else if(!take("t"))take("v");
  }
  return out;
}
var FEED=buildFeed(),cursor=0,photoIdx=0;
function make(item){
  if(item.type==="p")return photoCard(item.data,photoIdx++);
  if(item.type==="t")return tpCard(item.data);
  return videoCard(item.data);
}

function colCount(){var w=window.innerWidth;return w>=1100?4:w>=760?3:w>=480?2:1;}
function Grid(root){this.root=root;this.cards=[];this.n=0;this.cols=[];this.setCols(colCount());}
Grid.prototype.setCols=function(n){
  if(n===this.n)return;this.n=n;this.root.classList.remove("trv-level");this.root.textContent="";this.cols=[];
  for(var i=0;i<n;i++){var c=el("div","col");this.cols.push(c);this.root.appendChild(c);}
  var cards=this.cards;this.cards=[];for(var j=0;j<cards.length;j++)this.add(cards[j]);
  if(this.leveled)this.root.classList.add("trv-level");
};
Grid.prototype.add=function(card){
  var best=this.cols[0],bh=best.offsetHeight;
  for(var i=1;i<this.cols.length;i++){var h=this.cols[i].offsetHeight;if(h<bh-1){bh=h;best=this.cols[i];}}
  best.appendChild(card);this.cards.push(card);
};
var g1=new Grid(q("grid1")),g2=new Grid(q("grid2"));

function renderInto(g,count){var end=Math.min(FEED.length,cursor+count);for(;cursor<end;cursor++)g.add(make(FEED[cursor]));}
(function(){
  renderInto(g1,CONFIG.firstBlock);
  var cols=g1.cols;if(cols.length<2||cursor>=FEED.length)return;
  var GAP=parseFloat(getComputedStyle(cols[0]).rowGap)||24, W=cols[0].offsetWidth;
  var meas=el("div","col");meas.style.cssText="position:absolute;visibility:hidden;left:-9999px;top:0;width:"+W+"px";root.appendChild(meas);
  var pool=[];
  for(var i=cursor;i<Math.min(FEED.length,cursor+30);i++){var c=make(FEED[i]);meas.appendChild(c);pool.push({item:FEED[i],el:c,h:c.offsetHeight+GAP});}
  root.removeChild(meas);
  var hs=cols.map(function(c){return c.offsetHeight;}),top=Math.max.apply(null,hs),best=null;
  for(var H=top;H<=top+900;H+=6){
    var used={},plan=[],worst=0,count=0;
    var order=hs.map(function(h,ci){return ci;}).sort(function(a,b){return hs[a]-hs[b];});
    for(var oi=0;oi<order.length;oi++){
      var ci=order[oi],d=H-hs[ci],pick=[],rem=d;
      if(d>8){
        for(var a=0;a<pool.length;a++){if(used[a])continue;var ha=pool[a].h;
          if(ha<=d+8&&d-ha<rem){rem=d-ha;pick=[a];}
          for(var b=a+1;b<pool.length;b++){if(used[b])continue;var hb=ha+pool[b].h;
            if(hb<=d+8&&d-hb<rem){rem=d-hb;pick=[a,b];}}}
      }
      pick.forEach(function(x){used[x]=1;});count+=pick.length;
      plan.push({ci:ci,pick:pick});worst=Math.max(worst,Math.abs(rem));
    }
    var score=worst*10+count+(H-top)/100;
    if(!best||score<best.score)best={score:score,plan:plan};
    if(worst<10)break;
  }
  var chosen=[];
  best.plan.forEach(function(p){p.pick.forEach(function(x){cols[p.ci].appendChild(pool[x].el);g1.cards.push(pool[x].el);chosen.push(pool[x].item);});});
  var rest=FEED.slice(cursor).filter(function(x){return chosen.indexOf(x)<0;});
  FEED=FEED.slice(0,cursor).concat(chosen,rest);cursor+=chosen.length;
  g1.leveled=true;g1.root.classList.add("trv-level");
})();
renderInto(g2,CONFIG.pageSize);

var loadWrap=q("load"),sentinel=q("sentinel");
function more(){if(cursor<FEED.length)renderInto(g2,CONFIG.pageSize);if(cursor>=FEED.length){loadWrap.hidden=true;if(io)io.disconnect();}}
var io=null;
if("IntersectionObserver" in window){
  io=new IntersectionObserver(function(es){if(es[0].isIntersecting)more();},{rootMargin:"1200px 0px"});
  io.observe(sentinel);
}else{loadWrap.hidden=cursor>=FEED.length;}
q("load-btn").addEventListener("click",more);

Grid.prototype.relayout=function(){var n=this.n;this.n=0;this.setCols(n);};
var rt;window.addEventListener("resize",function(){clearTimeout(rt);rt=setTimeout(function(){var n=colCount();g1.setCols(n);g2.setCols(n);},150);});

var tw=q("tp-widget");if(tw)tpStars(parseFloat(tw.dataset.rating)||5,q("tp-stars"));

var fixed=q("cta-fixed");
if(fixed){
  var barOn=null,ticking=false;
  var firstRowBottom=function(){var b=-Infinity;g1.cols.forEach(function(c){var f=c.firstElementChild;if(f)b=Math.max(b,f.getBoundingClientRect().bottom);});return b;};
  var syncBar=function(){ticking=false;var past=firstRowBottom()<window.innerHeight/1;if(past===barOn)return;barOn=past;
    fixed.classList.toggle("trv-on",past);fixed.setAttribute("aria-hidden",past?"false":"true");fixed.inert=!past;};
  window.addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(syncBar);}},{passive:true});
  window.addEventListener("resize",function(){barOn=null;syncBar();});
  syncBar();
}

var lb=q("lb"),lbImg=q("lb-img"),lbSide=q("lb-side"),cur=null,ci=0;
function showImg(){
  lbImg.onerror=function(){lbImg.onerror=null;lbImg.src=JM_S3+cur.i[ci];};
  lbImg.src=JM_IMGIX+cur.i[ci]+"?auto=format,compress&w=1400";
  lbImg.alt="Photo "+(ci+1)+" of "+cur.i.length;
  [].forEach.call(lb.querySelectorAll(".trv-lb-nav"),function(b){b.hidden=cur.i.length<2;});
}
function openLB(r,i){
  cur=r;ci=i;showImg();lbSide.textContent="";
  var st=el("div","jm-stars");for(var s=0;s<(r.r||5);s++)st.appendChild(icon("star"));lbSide.appendChild(st);
  if(r.b)lbSide.appendChild(el("p","qt",r.b));
  lbSide.appendChild(who(cleanName(r.n),r.d));
  if(lb.showModal)lb.showModal();else lb.setAttribute("open","");
}
lb.addEventListener("click",function(e){
  var t=e.target.closest("[data-dir]");
  if(t){ci=(ci+ +t.dataset.dir+cur.i.length)%cur.i.length;showImg();return;}
  if(e.target===lb||e.target.closest("[data-close]"))lb.close();
});
lb.addEventListener("keydown",function(e){if(!cur||cur.i.length<2)return;if(e.key==="ArrowRight"){ci=(ci+1)%cur.i.length;showImg();}if(e.key==="ArrowLeft"){ci=(ci-1+cur.i.length)%cur.i.length;showImg();}});
}
function boot(){[].forEach.call(document.querySelectorAll("[data-trv-root]"),init);}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
document.addEventListener("shopify:section:load",function(e){var r=e.target.querySelector("[data-trv-root]");if(r)init(r);});
})();
